import { z } from "zod";

import { communityBroadcastSchema } from "./communityBroadcastSchema";

export const communityBroadcastsSchema = z.object({
  results: z.array(communityBroadcastSchema),
});

export type CommunityBroadcasts = z.TypeOf<typeof communityBroadcastsSchema>;
